<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <img class="logo" src="@/assets/images/logo.png" alt="logo" />
        <span class="title">沃助手</span>
      </div>
      
      <div class="login-content">
        <div class="login-banner">
          <img src="@/assets/images/login-banner.png" alt="login banner" />
        </div>
        
        <div class="login-form">
          <h2>欢迎登录沃助手</h2>
          <el-form :model="loginForm" ref="loginForm" :rules="rules">
            <el-form-item prop="phone" class="custom-form-item">
              <div class="input-with-icon">
                <i class="phone-icon"></i>
                <el-input 
                  v-model="loginForm.phone"
                  placeholder="手机号">
                </el-input>
              </div>
            </el-form-item>
            
            <el-form-item prop="verificationCode" class="custom-form-item">
              <div class="input-with-icon verification-code-container">
                <i class="verification-code-icon"></i>
                <el-input 
                  v-model="loginForm.verificationCode"
                  placeholder="验证码">
                </el-input>
                <div 
                  class="verification-code-button"
                  :class="{ 'is-disabled': isCountingDown }"
                  @click="sendVerificationCode">
                  {{ countDownText }}
                </div>
              </div>
            </el-form-item>

            <el-form-item>
              <div class="login-button" @click="handleLogin">登录</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <img
      class="image_1"
      referrerpolicy="no-referrer"
      src="@/assets/images/right-top.png"
    />
    <div class="group_1 flex-row">
      <div class="text-wrapper_1 flex-col">
        <!-- <span class="text_1">客服电话：15521090909</span> -->
      </div>
      <!-- <span class="text_2">官方网站：www.woqiyun.com</span> -->
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    
    return {
      loginForm: {
        phone: '',
        verificationCode: '',
        wsServers: 'wss://rtc.woqiyun.com:10062'
      },
      rules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '验证码长度应为6位', trigger: 'blur' }
        ]
      },
      countdown: 60,
      timer: null,
      isCountingDown: false
    }
  },
  computed: {
    countDownText() {
      return this.isCountingDown ? `${this.countdown}秒后重新发送` : '获取验证码'
    }
  },
  methods: {
    getBrowserInfo() {
      const ua = navigator.userAgent
      let browser = 'unknown'
      
      if (ua.indexOf('Chrome') > -1) {
        browser = 'Chrome'
      } else if (ua.indexOf('Firefox') > -1) {
        browser = 'Firefox'
      } else if (ua.indexOf('Safari') > -1) {
        browser = 'Safari'
      } else if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) {
        browser = 'IE'
      } else if (ua.indexOf('Edge') > -1) {
        browser = 'Edge'
      }
      
      return {
        browser,
        userAgent: ua
      }
    },
    async sendVerificationCode() {
      if (this.isCountingDown) return
      
      try {
        // 验证手机号
        await this.$refs.loginForm.validateField('phone')
        
        // 获取浏览器信息
        const browserInfo = this.getBrowserInfo()
        
        // 调用发送验证码API
        const res = await this.$http.post('/login/sendSmsCode', {
          phoneNumber: this.loginForm.phone,
          equipment: browserInfo.browser,
          system: 'PC'
        })
        
        if (res.data.result) {
          // 开始倒计时
          this.isCountingDown = true
          this.countdown = 60
          this.timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--
            } else {
              this.isCountingDown = false
              clearInterval(this.timer)
            }
          }, 1000)
          
          this.$message.success('验证码已发送')
        } else {
          this.$message.error(res.data.message || '发送验证码失败')
        }
      } catch (error) {
        this.$message.error(error.response?.data?.message || '发送验证码失败')
      }
    },
    
    async handleLogin() {
      try {
        await this.$refs.loginForm.validate()
        
        // 调用登录验证接口
        const res = await this.$http.post('/login/checkSmsCode', {
          phoneNumber: this.loginForm.phone,
          verificationCode: this.loginForm.verificationCode
        })
        
        if (res.data.result) {
          // 保存登录token
          localStorage.setItem('token', res.data.data.token)
          // 保存用户信息
          localStorage.setItem('userInfo', JSON.stringify(res.data.data))
          
          this.$message.success('登录成功')
          this.$router.push('/dialer')
        } else {
          this.$message.error(res.data.message || '登录失败')
        }
      } catch (error) {
        this.$message.error(error.response?.data?.message || '登录失败')
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .login-card {
    position: relative;
    z-index: 1;
    width: calc(100% - 120px);
    height: 600px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    
    .login-header {
      padding: 20px;
      display: flex;
      align-items: center;
      gap: 10px;
      
      .logo {
        height: 70px;
      }
      
      .title {
        font-size: 30px;
        font-weight: 600;
        color: #333;
      }
    }
    
    .login-content {
      flex: 1;
      display: flex;
      
      .login-banner {
        flex: 1;
        margin-left: 100px;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      
      .login-form {
        flex: 1;
        padding: 40px 200px;
        background: #fff;
        
        h2 {
          font-size: 24px;
          font-weight: 600;
          color: #333;
          margin-bottom: 30px;
          text-align: center;
        }
        
        .custom-form-item {
          margin-bottom: 24px;
          
          .input-with-icon {
            display: flex;
            align-items: center;
            background: #f5f7fa;
            border-radius: 8px;
            padding: 0 16px;
            
            i {
              width: 32px;
              height: 32px;
              margin-right: 12px;
              
              &.phone-icon {
                background: url('@/assets/images/phone-icon.png') no-repeat center / contain;
              }
              
              &.verification-code-icon {
                background: url('@/assets/images/verification-code-icon.png') no-repeat center / contain;
              }
            }
            
            .el-input {
              flex: 1;
              
              /deep/ .el-input__inner {
                border: none;
                background: transparent;
                height: 48px;
                font-size: 16px;
                
                &::placeholder {
                  color: #999;
                }
              }
            }
          }
          
          .verification-code-container {
            .verification-code-button {
              padding: 0 20px;
              height: 48px;
              line-height: 48px;
              color: #5579E7;
              font-size: 14px;
              cursor: pointer;
              white-space: nowrap;
              
              &.is-disabled {
                color: #999;
                cursor: not-allowed;
              }
            }
          }
        }
        
        .login-button {
          width: 100%;
          height: 48px;
          line-height: 48px;
          text-align: center;
          background: #5579E7;
          color: #fff;
          font-size: 16px;
          border-radius: 24px;
          cursor: pointer;
          transition: all 0.3s;
          
          &:hover {
            background: darken(#5579E7, 5%);
          }
        }
      }
    }
    
    
  }
  .login-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 16px;
      
      .contact-info {
        display: flex;
        justify-content: center;
        gap: 40px;
        color: #666;
        font-size: 14px;
      }
    }
    .image_1 {
    position: absolute;
    right: 0;
    top: 0;
    width: 54.64vw;
    height: 23.7vw;
    z-index: 0;
  }
  .group_1 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 73.23vw;
    height: 23.7vw;
    margin-top: 8.86vw;
    .text-wrapper_1 {
      height: 23.7vw;
      background: url(@/assets/images/left-bottom.png)
        100% no-repeat;
      background-size: 100% 100%;
      width: 54.64vw;
      .text_1 {
        width: 16.36vw;
        height: 2.09vw;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 1.45vw;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 2.09vw;
        margin: 19.95vw 0 0 31.04vw;
      }
    }
    .text_2 {
      width: 19.85vw;
      height: 2.09vw;
      overflow-wrap: break-word;
      color: rgba(83, 119, 227, 1);
      font-size: 1.45vw;
      font-weight: NaN;
      text-align: left;
      white-space: nowrap;
      line-height: 2.09vw;
      margin: 19.95vw 0 0 -1.25vw;
    }
  }
}
</style>